import { Images } from "@gaiaProfessionals/Services/MeetYourHerbsService";
import { CustomMeetYourHerbsState } from "@gaiaProfessionals/Store/MeetYourHerbs/GAIAMeetYourHerbsReducer";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import { getCurrentUserIsGuest } from "@insite/client-framework/Store/Context/ContextSelectors";
import { WidgetGroup } from "@insite/client-framework/Types/WidgetGroups";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Img, { ImgProps } from "@insite/mobius/Img";
import { LazyImageProps } from "@insite/mobius/LazyImage";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomMeetYourHerbsState) => {
    let images = state.customMeetYourHerbsReducer?.productData?.images;
    const primaryImageId = state.customMeetYourHerbsReducer?.productData?.properties?.primaryImageId;

    if (images && images.length) {
        images = images.filter(item => item.id !== primaryImageId)
    }
    return {
        image: images?.length ? images[0] : null,
        userName: state.context.session.userName,
        url: state.customMeetYourHerbsReducer?.productData?.canonicalUrl,

    }
}

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & HasHistory;

export interface GAIAMYHProductImageStyles {
    mainWrapper?: InjectableCss;
    image?: LazyImageProps;
    img?: ImgProps;
}
const styles: GAIAMYHProductImageStyles = {
    mainWrapper: {
        css: css`
                display: flex;
                justify-content: center;
                width: 100%;

            `,
    },
    image: {
        css: css`
                img {
                    height: 100%;
                }
            `,
    },
    img: {
        css: css`
                height: auto;
                width: 100%;
                max-height:434px;
                max-width:434px;
            `,
    },
};

const GAIAMYHProductImage: React.FC<Props> = ({ image }) => {

    return (
        <StyledWrapper {...styles.mainWrapper}>

            {image ? <Img {...styles.img} width="209" height="209" src={image.mediumImagePath} altText={image.imageAltText} /> : ''
            }
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withHistory(GAIAMYHProductImage)),
    definition: {
        displayName: "GAIA MYH Product Image",
        group: "MYH Product Details" as WidgetGroup,
    },
};

export default widgetModule;
